export default __webpack_public_path__ + "static/media/next.7ed6ea66.png";